<template>
    <section class="order" id="order">
        <div class="container vld-parent">
            <loading :active.sync="isLoading" :background-color="'#000'" :color="'#ecd19a'" :opacity="0.7"></loading>
            <div class="centered">
                If you made a purchase but do not see it reflected on your account page you can submit your order id below.<br />
                Copy the Order Id from the receipt you received from My Commerce via email into the box below and click submit.
            </div>
            <div class="row">
                <div class="order-id-form">
                    <div class="col-xs-6 contact-form centered">
                        <div style="padding-left: 1em;">
                            <div class="row">
                                <input type="text" name="key" id="name" style="width: 100%;" v-model="orderid">
                            </div>
                            <div class="row">
                                <button class="outline-btn" @click="onKeyProcessClick" >Process Order</button> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    
    export default {
        name: 'OrderComponent',
        components: { Loading },
        data() {
            return {
                orderid: "",
                isLoading: false
            }
        },
        methods: {
            onKeyProcessClick(event){
                if (event) {
                    event.preventDefault();
                }
                this.isLoading = true;
                this.axios.post(this.$config.api_url + "/My/Keys?key=" + this.orderid, null, { withCredentials: true }).then(() => {
                    this.$toast.success('Order Processed');
                    this.isLoading = false;
                    this.$router.push('Account');
                }).catch(() => {
                    this.$toast.error('Error Processing Order, Please Try again');
                    this.isLoading = false;
                });
            }
        }
    }
</script> 